import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-space-sidebar',
  templateUrl: './space-sidebar.component.html',
  styleUrls: ['./space-sidebar.component.scss']
})
export class SpaceSidebarComponent implements OnInit {
  @Input() singleSpaceData;
  active: any;
  constructor() { }

  ngOnInit() {
  }

}
